// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ARgkqh {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.GDHZKD {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.rmXe8o {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.yONBWw {
  padding: var(--spacing-3) var(--spacing-1-5) 0;
  border: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

.zyhvPt {
  background: none;
  border: none;
  padding: var(--spacing-0-5);
  width: var(--spacing-3);
  height: var(--spacing-3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: calc(-1 * var(--spacing-0-5));
}

.zyhvPt img {
  width: var(--spacing-2);
  height: var(--spacing-2);
}

.oXAuXU {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.vnIrqu {
  padding: var(--spacing-3);
  overflow-y: auto;
  min-height: 0;
  flex: 1;
}

.pjir0O {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.H1Z_PE {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
}

.S3O6Fh {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
}

._2krOT6 {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-2);
}

.Y3f3mg {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--spacing-1-5);
}

.APR7UX {
  padding: var(--spacing-3);
  border-top: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-2);
  background: var(--surface-neutral-white);
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
}

.obaOzf {
  background-color: var(--neutral-dark-opacity-50) !important;
}

.T9kwcW {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BeneficiaryFilter/components/BeneficiaryFilterModal/BeneficiaryFilterModal.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-1-5) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: var(--spacing-0-5);\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin: calc(-1 * var(--spacing-0-5));\n}\n\n.backButton img {\n  width: var(--spacing-2);\n  height: var(--spacing-2);\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.modalBody {\n  padding: var(--spacing-3);\n  overflow-y: auto;\n  min-height: 0;\n  flex: 1;\n}\n\n.filtersContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.filterGroup {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n}\n\n.filterGroupTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.dateFieldsContainer {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-2);\n}\n\n.checkboxesContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: var(--spacing-1-5);\n}\n\n.modalFooter {\n  padding: var(--spacing-3);\n  border-top: none;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-2);\n  background: var(--surface-neutral-white);\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.backdrop {\n  background-color: var(--neutral-dark-opacity-50) !important;\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `ARgkqh`,
	"modalDialog": `GDHZKD`,
	"modalContent": `rmXe8o`,
	"modalHeader": `yONBWw`,
	"backButton": `zyhvPt`,
	"modalTitle": `oXAuXU`,
	"modalBody": `vnIrqu`,
	"filtersContainer": `pjir0O`,
	"filterGroup": `H1Z_PE`,
	"filterGroupTitle": `S3O6Fh`,
	"dateFieldsContainer": `_2krOT6`,
	"checkboxesContainer": `Y3f3mg`,
	"modalFooter": `APR7UX`,
	"backdrop": `obaOzf`,
	"loadingContainer": `T9kwcW`
};
module.exports = ___CSS_LOADER_EXPORT___;
